(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gaiwan-size-guide"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (root) => {
      root.querySelectorAll('[data-gaiwan-size-guide]').forEach((section) => {
        if (section.dataset.sizeGuideReady === 'true') return;

        const track = section.querySelector('[data-size-guide-track]');
        const cards = Array.from(section.querySelectorAll('[data-size-guide-card]'));
        const dots = Array.from(section.querySelectorAll('[data-size-guide-dot]'));

        if (!track || cards.length < 2 || dots.length === 0) return;
        section.dataset.sizeGuideReady = 'true';

        let frame;

        const setActiveDot = () => {
          const trackLeft = track.getBoundingClientRect().left;
          let activeIndex = 0;
          let shortestDistance = Number.POSITIVE_INFINITY;

          cards.forEach((card, index) => {
            const distance = Math.abs(card.getBoundingClientRect().left - trackLeft);
            if (distance < shortestDistance) {
              shortestDistance = distance;
              activeIndex = index;
            }
          });

          dots.forEach((dot, index) => {
            const isActive = index === activeIndex;
            dot.classList.toggle('is-active', isActive);
            if (isActive) {
              dot.setAttribute('aria-current', 'true');
            } else {
              dot.removeAttribute('aria-current');
            }
          });
        };

        const requestDotUpdate = () => {
          window.cancelAnimationFrame(frame);
          frame = window.requestAnimationFrame(setActiveDot);
        };

        dots.forEach((dot, index) => {
          dot.addEventListener('click', () => {
            const card = cards[index];
            const left = track.scrollLeft + card.getBoundingClientRect().left - track.getBoundingClientRect().left;
            track.scrollTo({ left, behavior: 'smooth' });
          });
        });

        track.addEventListener('scroll', requestDotUpdate, { passive: true });

        if ('ResizeObserver' in window) {
          const observer = new ResizeObserver(requestDotUpdate);
          observer.observe(track);
        }

        setActiveDot();
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialize(document));
    } else {
      initialize(document);
    }

    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gongfu-setup-builder"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gongfu-setup-builder')) {
    customElements.define('gongfu-setup-builder', class GongfuSetupBuilder extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.selection = new Map();
        this.currency = this.dataset.currency || 'USD';
        this.locale = this.dataset.locale || document.documentElement.lang || 'en';
        this.shippingThreshold = Number(this.dataset.shippingThreshold || 0);
        this.discountThreshold = Number(this.dataset.discountThreshold || 0);
        this.discountPercent = Number(this.dataset.discountPercent || 0);
        this.cartTotal = Number(this.dataset.cartTotal || 0);
        this.lastFocus = null;
        this.bindEvents();
        this.hydrateProductPool(this.querySelector('[data-product-pool]'));
        this.initProductCarousels(this);
        this.loadRemainingProducts();
        this.render();
      }

      hydrateProductPool(pool) {
        if (!pool) return;
        pool.querySelectorAll('[data-product-card]').forEach((card) => {
          const grid = this.querySelector(`[data-product-grid="${CSS.escape(card.dataset.step)}"]`);
          if (!grid) return;
          if (grid.querySelector(`[data-card-id="${CSS.escape(card.dataset.cardId)}"]`)) return;
          grid.querySelector('.sbg-empty-step')?.remove();
          grid.appendChild(card);
          this.initProductCarousels(card);
        });
      }

      async loadRemainingProducts() {
        let nextUrl = this.querySelector('[data-product-pool]')?.dataset.nextUrl;
        const loadedUrls = new Set();

        while (nextUrl && !loadedUrls.has(nextUrl)) {
          loadedUrls.add(nextUrl);
          try {
            const url = new URL(nextUrl, window.location.origin);
            url.searchParams.set('section_id', this.dataset.sectionId);
            const response = await fetch(url.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
            if (!response.ok) break;
            const html = await response.text();
            const documentFragment = new DOMParser().parseFromString(html, 'text/html');
            const remotePool = documentFragment.querySelector('[data-product-pool]');
            if (!remotePool) break;

            remotePool.querySelectorAll('[data-product-card]').forEach((card) => {
              const importedCard = document.importNode(card, true);
              const grid = this.querySelector(`[data-product-grid="${CSS.escape(importedCard.dataset.step)}"]`);
              if (!grid) return;
              if (this.querySelector(`[data-card-id="${CSS.escape(importedCard.dataset.cardId)}"]`)) return;
              grid.querySelector('.sbg-empty-step')?.remove();
              grid.appendChild(importedCard);
              this.initProductCarousels(importedCard);
            });
            nextUrl = remotePool.dataset.nextUrl;
          } catch (error) {
            break;
          }
        }
      }

      bindEvents() {
        this.addEventListener('click', (event) => {
          const minus = event.target.closest('[data-quantity-minus]');
          const plus = event.target.closest('[data-quantity-plus]');
          const toggle = event.target.closest('[data-card-toggle]');
          const remove = event.target.closest('[data-remove-card]');
          const open = event.target.closest('[data-summary-open]');
          const close = event.target.closest('[data-summary-close], [data-summary-overlay]');
          const addAll = event.target.closest('[data-add-all]');
          const stepButton = event.target.closest('[data-scroll-step]');
          const galleryPrevious = event.target.closest('[data-gallery-previous]');
          const galleryNext = event.target.closest('[data-gallery-next]');

          if (galleryPrevious || galleryNext) {
            event.preventDefault();
            event.stopPropagation();
            this.moveGallery(event.target.closest('[data-product-card]'), galleryNext ? 1 : -1);
          }

          if (minus || plus) {
            const card = event.target.closest('[data-product-card]');
            const input = card.querySelector('[data-quantity]');
            const delta = plus ? 1 : -1;
            input.value = Math.min(12, Math.max(1, Number(input.value || 1) + delta));
            this.updateSelectedCard(card);
          }

          if (toggle) this.toggleCard(event.target.closest('[data-product-card]'));
          if (remove) this.removeCard(remove.dataset.removeCard);
          if (open) this.openSummary(open);
          if (close) this.closeSummary();
          if (addAll) this.addAllToCart();
          if (stepButton) this.goToStep(stepButton.dataset.scrollStep);
        });

        this.addEventListener('change', (event) => {
          const card = event.target.closest('[data-product-card]');
          if (!card) return;
          if (event.target.matches('[data-variant-select]')) this.handleVariantChange(card);
          if (event.target.matches('[data-quantity]')) this.updateSelectedCard(card);
        });

        this.addEventListener('input', (event) => {
          if (!event.target.matches('[data-quantity]')) return;
          event.target.value = Math.min(12, Math.max(1, Number(event.target.value || 1)));
          this.updateSelectedCard(event.target.closest('[data-product-card]'));
        });

        document.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && this.classList.contains('is-summary-open')) this.closeSummary();
        });
      }

      getVariantElement(card) {
        return card.querySelector('[data-variant-select]');
      }

      initProductCarousels(scope) {
        const galleries = scope.matches?.('[data-product-gallery]')
          ? [scope]
          : scope.querySelectorAll?.('[data-product-gallery]') || [];

        galleries.forEach((gallery) => {
          if (gallery.dataset.galleryReady === 'true') return;
          gallery.dataset.galleryReady = 'true';
          const track = gallery.querySelector('[data-gallery-track]');
          if (!track) return;
          let frame;
          track.addEventListener('scroll', () => {
            cancelAnimationFrame(frame);
            frame = requestAnimationFrame(() => this.syncGalleryFromScroll(gallery));
          }, { passive: true });
          this.updateGalleryControls(gallery, 0);
        });
      }

      syncGalleryFromScroll(gallery) {
        const track = gallery.querySelector('[data-gallery-track]');
        if (!track || track.clientWidth === 0) return;
        const index = Math.round(track.scrollLeft / track.clientWidth);
        this.updateGalleryControls(gallery, index);
      }

      updateGalleryControls(gallery, requestedIndex) {
        const slides = Array.from(gallery.querySelectorAll('[data-gallery-slide]'));
        if (slides.length === 0) return;
        const index = Math.min(slides.length - 1, Math.max(0, requestedIndex));
        gallery.dataset.galleryIndex = String(index);
        slides.forEach((slide, slideIndex) => slide.classList.toggle('is-active', slideIndex === index));
        const previous = gallery.querySelector('[data-gallery-previous]');
        const next = gallery.querySelector('[data-gallery-next]');
        if (previous) previous.disabled = index === 0;
        if (next) next.disabled = index === slides.length - 1;
        const count = gallery.querySelector('[data-gallery-count]');
        if (count) count.textContent = `${index + 1} / ${slides.length}`;
      }

      setGalleryIndex(card, requestedIndex, behavior = 'smooth') {
        const gallery = card?.querySelector('[data-product-gallery]');
        const track = gallery?.querySelector('[data-gallery-track]');
        const slides = gallery ? Array.from(gallery.querySelectorAll('[data-gallery-slide]')) : [];
        if (!gallery || !track || slides.length === 0) return;
        const index = Math.min(slides.length - 1, Math.max(0, requestedIndex));
        track.scrollTo({ left: slides[index].offsetLeft, behavior });
        this.updateGalleryControls(gallery, index);
      }

      moveGallery(card, direction) {
        const gallery = card?.querySelector('[data-product-gallery]');
        const index = Number(gallery?.dataset.galleryIndex || 0);
        this.setGalleryIndex(card, index + direction);
      }

      getVariantData(card) {
        const field = this.getVariantElement(card);
        const source = field.tagName === 'SELECT' ? field.options[field.selectedIndex] : field;
        return {
          id: Number(field.value),
          price: Number(source.dataset.price || 0),
          priceFormatted: source.dataset.priceFormatted || '',
          available: source.dataset.available === 'true',
          variantTitle: source.dataset.variantTitle || '',
          imageId: source.dataset.imageId || '',
          image: source.dataset.image || card.querySelector('.sbg-product-card__image')?.src || '',
          url: source.dataset.url || ''
        };
      }

      handleVariantChange(card) {
        const variant = this.getVariantData(card);
        const button = card.querySelector('[data-card-toggle]');
        const price = card.querySelector('[data-card-price]');
        price.textContent = variant.priceFormatted;
        button.disabled = !variant.available;
        if (variant.imageId) {
          const slides = Array.from(card.querySelectorAll('[data-gallery-slide]'));
          const imageIndex = slides.findIndex((slide) => slide.dataset.imageId === String(variant.imageId));
          if (imageIndex >= 0) this.setGalleryIndex(card, imageIndex);
        }
        if (variant.url) {
          card.querySelectorAll('[data-product-link]').forEach((link) => {
            link.href = variant.url;
          });
        }
        this.updateSelectedCard(card);
      }

      toggleCard(card) {
        if (!card) return;
        if (this.selection.has(card.dataset.cardId)) {
          this.removeCard(card.dataset.cardId);
          return;
        }
        const variant = this.getVariantData(card);
        if (!variant.available) return;
        this.selection.set(card.dataset.cardId, this.cardPayload(card));
        card.classList.add('is-selected');
        const button = card.querySelector('[data-card-toggle]');
        button.textContent = button.dataset.removeLabel;
        button.setAttribute('aria-pressed', 'true');
        this.render();
      }

      cardPayload(card) {
        const variant = this.getVariantData(card);
        return {
          cardId: card.dataset.cardId,
          step: card.dataset.step,
          productTitle: card.dataset.productTitle,
          variantId: variant.id,
          variantTitle: variant.variantTitle,
          price: variant.price,
          priceFormatted: variant.priceFormatted,
          image: variant.image,
          quantity: Math.min(12, Math.max(1, Number(card.querySelector('[data-quantity]').value || 1)))
        };
      }

      updateSelectedCard(card) {
        if (!card || !this.selection.has(card.dataset.cardId)) return;
        const variant = this.getVariantData(card);
        if (!variant.available) {
          this.removeCard(card.dataset.cardId);
          return;
        }
        this.selection.set(card.dataset.cardId, this.cardPayload(card));
        this.render();
      }

      removeCard(cardId) {
        this.selection.delete(cardId);
        const card = this.querySelector(`[data-card-id="${CSS.escape(cardId)}"]`);
        if (card) {
          card.classList.remove('is-selected');
          const button = card.querySelector('[data-card-toggle]');
          button.textContent = button.dataset.addLabel;
          button.setAttribute('aria-pressed', 'false');
        }
        this.render();
      }

      formatMoney(cents) {
        try {
          return new Intl.NumberFormat(this.locale, { style: 'currency', currency: this.currency }).format(cents / 100);
        } catch (error) {
          return `${this.currency} ${(cents / 100).toFixed(2)}`;
        }
      }

      render() {
        const items = Array.from(this.selection.values());
        const itemCount = items.reduce((sum, item) => sum + item.quantity, 0);
        const subtotal = items.reduce((sum, item) => sum + (item.price * item.quantity), 0);
        this.querySelectorAll('[data-item-count]').forEach((node) => { node.textContent = itemCount; });
        this.querySelectorAll('[data-subtotal]').forEach((node) => { node.textContent = this.formatMoney(subtotal); });
        this.querySelectorAll('[data-add-all]').forEach((button) => { button.disabled = itemCount === 0; });

        this.querySelectorAll('[data-step-count]').forEach((node) => {
          const count = items.filter((item) => item.step === node.dataset.stepCount).reduce((sum, item) => sum + item.quantity, 0);
          node.textContent = count;
        });

        this.renderDiscount(subtotal);
        this.renderShipping(subtotal);
        this.renderMiniSlots(items);
        this.renderSummary(items);
      }

      renderDiscount(subtotal) {
        const remaining = Math.max(0, this.discountThreshold - subtotal);
        const percent = this.discountThreshold > 0 ? Math.min(100, (subtotal / this.discountThreshold) * 100) : 100;
        const message = remaining === 0
          ? this.dataset.discountUnlockedLabel.replace('[percent]', this.discountPercent)
          : this.dataset.discountAwayLabel
              .replace('[amount]', this.formatMoney(remaining))
              .replace('[percent]', this.discountPercent);
        const messageNode = this.querySelector('[data-discount-message]');
        const progressFill = this.querySelector('[data-discount-progress-fill]');
        if (messageNode) messageNode.textContent = message;
        if (progressFill) progressFill.style.width = `${percent}%`;
      }

      renderShipping(subtotal) {
        const projectedTotal = this.cartTotal + subtotal;
        const remaining = Math.max(0, this.shippingThreshold - projectedTotal);
        const percent = this.shippingThreshold > 0 ? Math.min(100, (projectedTotal / this.shippingThreshold) * 100) : 100;
        const message = remaining === 0
          ? this.dataset.freeShippingLabel
          : this.dataset.awayLabel.replace('[amount]', this.formatMoney(remaining));
        this.querySelectorAll('[data-shipping-message]').forEach((node) => { node.textContent = message; });
        this.querySelectorAll('[data-shipping-progress-fill]').forEach((node) => { node.style.width = `${percent}%`; });
      }

      renderMiniSlots(items) {
        const slots = this.querySelectorAll('[data-mini-slots] > span');
        slots.forEach((slot, index) => {
          slot.replaceChildren();
          if (!items[index]?.image) return;
          const img = document.createElement('img');
          img.src = items[index].image;
          img.alt = '';
          slot.appendChild(img);
        });
      }

      renderSummary(items) {
        const container = this.querySelector('[data-summary-items]');
        container.replaceChildren();
        if (!items.length) {
          const empty = document.createElement('p');
          empty.className = 'sbg-summary__empty';
          empty.textContent = this.dataset.emptyLabel;
          container.appendChild(empty);
          return;
        }

        items.forEach((item) => {
          const row = document.createElement('div');
          row.className = 'sbg-summary-item';
          if (item.image) {
            const img = document.createElement('img');
            img.src = item.image;
            img.alt = '';
            row.appendChild(img);
          } else {
            row.appendChild(document.createElement('span'));
          }

          const info = document.createElement('div');
          info.className = 'sbg-summary-item__info';
          const title = document.createElement('strong');
          title.textContent = item.productTitle;
          const variant = document.createElement('span');
          variant.textContent = item.variantTitle && item.variantTitle !== 'Default Title' ? item.variantTitle : '';
          const meta = document.createElement('span');
          meta.textContent = `${item.quantity} × ${item.priceFormatted}`;
          info.append(title, variant, meta);

          const remove = document.createElement('button');
          remove.type = 'button';
          remove.dataset.removeCard = item.cardId;
          remove.textContent = this.dataset.removeLabel;
          row.append(info, remove);
          container.appendChild(row);
        });
      }

      goToStep(step) {
        const details = this.querySelector(`[data-step-details="${CSS.escape(step)}"]`);
        if (!details) return;
        details.open = true;
        details.scrollIntoView({ behavior: 'smooth', block: 'start' });
        this.querySelectorAll('[data-scroll-step]').forEach((button) => {
          button.classList.toggle('is-active', button.dataset.scrollStep === step);
        });
      }

      openSummary(trigger) {
        this.lastFocus = trigger;
        this.classList.add('is-summary-open');
        this.querySelector('[data-summary]').setAttribute('aria-hidden', 'false');
        this.querySelectorAll('[data-summary-open]').forEach((button) => button.setAttribute('aria-expanded', 'true'));
        document.documentElement.style.overflow = 'hidden';
        this.querySelector('[data-summary-close]')?.focus();
      }

      closeSummary() {
        this.classList.remove('is-summary-open');
        this.querySelector('[data-summary]').setAttribute('aria-hidden', 'true');
        this.querySelectorAll('[data-summary-open]').forEach((button) => button.setAttribute('aria-expanded', 'false'));
        document.documentElement.style.overflow = '';
        this.lastFocus?.focus();
      }

      async addAllToCart() {
        const buttons = this.querySelectorAll('[data-add-all]');
        buttons.forEach((button) => { button.disabled = true; button.setAttribute('aria-busy', 'true'); });
        this.setStatus('');
        const items = Array.from(this.selection.values()).map((item) => ({
          id: item.variantId,
          quantity: item.quantity,
          properties: { '_Setup': 'Build Your Own Gongfu Setup' }
        }));

        try {
          const root = window.Shopify?.routes?.root || '/';
          const response = await fetch(`${root}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items })
          });
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || result.message || this.dataset.errorLabel);

          this.dispatchEvent(new CustomEvent('gongfu-setup:added', { bubbles: true, detail: result }));
          document.dispatchEvent(new CustomEvent('cart:refresh', { detail: result }));
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: result }));

          if (this.dataset.redirectToCart === 'true') {
            window.location.assign(`${root}cart`);
            return;
          }
          this.setStatus(this.dataset.addedLabel);
          buttons.forEach((button) => { button.textContent = this.dataset.addedLabel; });
        } catch (error) {
          this.setStatus(error.message || this.dataset.errorLabel);
          buttons.forEach((button) => { button.disabled = false; });
        } finally {
          buttons.forEach((button) => button.removeAttribute('aria-busy'));
        }
      }

      setStatus(message) {
        const status = this.querySelector('[data-status]');
        if (status) status.textContent = message;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      if (this.header) {
        observer.observe(this.header);
      }
    }

    onScroll() {
      if (this.header.querySelector('details-modal details').hasAttribute('open')) {
        return;
      }

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.headerIsAlwaysSticky && scrollTop > this.header.offsetHeight + 1) {
        this.header.classList.add('shopify-section-header-sticky');
        this.header.style.transform = 'translateY(-100%)';
      }

      if (this.headerIsAlwaysSticky && scrollTop > this.header.offsetHeight + 2) {
        this.header.style.transition = 'background var(--duration-short), transform var(--duration-default)';
        this.header.style.transform = 'translateY(0)';
      }

      if (this.headerIsAlwaysSticky && scrollTop < this.header.offsetHeight) {
        this.header.classList.remove('shopify-section-header-sticky');
        this.header.style.transform = 'translateY(0)';
        this.header.style.transition = 'background var(--duration-short)';
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.predictiveSearch && this.predictiveSearch.onFocusOut) {
          this.predictiveSearch.onFocusOut();
          this.predictiveSearch.onBlur();
        }
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      if (this.disclosures) {
        this.disclosures.forEach((disclosure) => disclosure.close());
      }
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener(
        'change',
        debounce((event) => {
          const body = JSON.stringify({ note: event.target.value });
          fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
        }, 300)
      );
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  window.addEventListener('DOMContentLoaded', () => {
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
        window.pauseAllMedia();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube') &&
          activeMediaContent.querySelector('.js-vimeo')
        )
          activeMedia.loadContent();
      }
    }

    class RelatedProduct extends HTMLElement {
      constructor() {
        super();

        const handleIntersection = (entries, observer) => {
          if (!entries[0].isIntersecting) return;
          observer.unobserve(this);

          fetch(this.dataset.url)
            .then((response) => response.text())
            .then((text) => {
              const html = document.createElement('div');
              html.innerHTML = text;
              const related = html.querySelector('.related-product');
              if (related && related.innerHTML.trim().length) {
                this.innerHTML = related.innerHTML;
              }

              /* Toggle content */
              $('.product-description-more').click(function (e) {
                e.preventDefault();
                $(this).closest('.product-description-short').next().show();
                $(this).closest('.product-description-short').hide();
              });

              $('.product-description-less').click(function (e) {
                e.preventDefault();
                $(this).closest('.product-description-full').prev().show();
                $(this).closest('.product-description-full').hide();
              });
            })
            .catch((e) => {
              console.error(e);
            });
        };

        new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this);
      }
    }

    class RelatedSlider extends HTMLElement {
      constructor() {
        super();

        const handleIntersection = (entries, observer) => {
          if (!entries[0].isIntersecting) return;
          observer.unobserve(this);

          fetch(this.dataset.url)
            .then((response) => response.text())
            .then((text) => {
              const html = document.createElement('div');
              html.innerHTML = text;
              const relatedSlider = html.querySelector(`related-slider[data-id="${this.getAttribute('data-id')}"]`);
              if (relatedSlider && relatedSlider.innerHTML.trim().length) {
                this.innerHTML = relatedSlider.innerHTML;
              }

              /* Related products slider */
              const slider = this.querySelector('.related-slider__list');
              const prevBtn = this.querySelector('.related-slider__button-prev');
              const nextBtn = this.querySelector('.related-slider__button-next');
              if (document.querySelector('.related-slider__list')) {
                const productSlider = new Swiper(slider, {
                  slidesPerView: 1,
                  spaceBetween: 10,
                  allowTouchMove: true,
                  watchSlidesProgress: true,
                  preventInteractionOnTransition: true,
                  mousewheel: {
                    forceToAxis: true,
                  },
                  navigation: {
                    nextEl: nextBtn,
                    prevEl: prevBtn,
                  },
                  breakpoints: {},
                });
              }

              /* Color swatches */
              const generateSrcset = (image, widths = []) => {
                const imageUrl = new URL(image['src']);
                return widths
                  .filter((width) => width <= image['width'])
                  .map((width) => {
                    imageUrl.searchParams.set('width', width.toString());
                    return `${imageUrl.href} ${width}w`;
                  })
                  .join(', ');
              };

              const createImageElement = (image, classes, sizes, productTitle) => {
                const previewImage = image['preview_image'];
                const newImage = new Image(previewImage['width'], previewImage['height']);
                newImage.className = classes;
                newImage.alt = image['alt'] || productTitle;
                newImage.sizes = sizes;
                newImage.src = previewImage['src'];
                newImage.srcset = generateSrcset(previewImage, [165, 360, 533, 720, 940, 1066]);
                newImage.loading = 'lazy';
                return newImage;
              };

              const checkSwatches = () => {
                document.querySelectorAll('.js-color-swatches-wrapper').forEach((wrapper) => {
                  wrapper.querySelectorAll('.js-color-swatches input').forEach((input) => {
                    input.addEventListener('click', (event) => {
                      const primaryImage = wrapper.querySelector('.media--first');
                      const secondaryImage = wrapper.querySelector('.media--second');
                      const handleProduct = wrapper.dataset.product;

                      if (event.currentTarget.checked && primaryImage) {
                        wrapper
                          .querySelector('.js-color-swatches-link')
                          .setAttribute('href', event.currentTarget.dataset.variantLink);
                        if (wrapper.querySelector('.card__add-to-cart button[name="add"]')) {
                          wrapper
                            .querySelector('.card__add-to-cart button[name="add"]')
                            .setAttribute('aria-disabled', false);
                          wrapper
                            .querySelector('.card__add-to-cart button[name="add"] > span')
                            .classList.remove('hidden');
                          wrapper
                            .querySelector('.card__add-to-cart button[name="add"] .sold-out-message')
                            .classList.add('hidden');
                          wrapper.querySelector('.card__add-to-cart input[name="id"]').value =
                            event.currentTarget.dataset.variantId;
                        }

                        const currentColor = event.currentTarget.value;

                        jQuery.getJSON(window.Shopify.routes.root + `products/${handleProduct}.js`, function (product) {
                          const variant = product.variants.filter(
                            (item) => item.featured_media != null && item.options.includes(currentColor)
                          )[0];

                          if (variant) {
                            const newPrimaryImage = createImageElement(
                              variant['featured_media'],
                              primaryImage.className,
                              primaryImage.sizes,
                              product.title
                            );

                            if (newPrimaryImage.src !== primaryImage.src) {
                              let flag = false;
                              if (secondaryImage) {
                                const secondaryImagePathname = new URL(secondaryImage.src).pathname;
                                const newPrimaryImagePathname = new URL(newPrimaryImage.src).pathname;

                                if (secondaryImagePathname == newPrimaryImagePathname) {
                                  primaryImage.remove();
                                  secondaryImage.classList.remove('media--second');
                                  secondaryImage.classList.add('media--first');
                                  flag = true;
                                }
                              }
                              if (flag == false) {
                                primaryImage.animate(
                                  { opacity: [1, 0] },
                                  { duration: 200, easing: 'ease-in', fill: 'forwards' }
                                ).finished;
                                setTimeout(function () {
                                  primaryImage.replaceWith(newPrimaryImage);
                                  newPrimaryImage.animate({ opacity: [0, 1] }, { duration: 200, easing: 'ease-in' });
                                  if (secondaryImage) {
                                    secondaryImage.remove();
                                  }
                                }, 200);
                              }
                            }
                          }
                        });
                      }
                    });
                  });
                });
              };

              checkSwatches();
            })
            .catch((e) => {
              console.error(e);
            });
        };

        new IntersectionObserver(handleIntersection.bind(this), {
          rootMargin: '0px 0px 200px 0px',
        }).observe(this);
      }
    }

    customElements.define('product-modal', ProductModal);
    customElements.define('related-product', RelatedProduct);
    customElements.define('related-slider', RelatedSlider);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            /* Color swatches */
            const generateSrcset = (image, widths = []) => {
              const imageUrl = new URL(image['src']);
              return widths
                .filter((width) => width <= image['width'])
                .map((width) => {
                  imageUrl.searchParams.set('width', width.toString());
                  return `${imageUrl.href} ${width}w`;
                })
                .join(', ');
            };

            const createImageElement = (image, classes, sizes, productTitle) => {
              const previewImage = image['preview_image'];
              const newImage = new Image(previewImage['width'], previewImage['height']);
              newImage.className = classes;
              newImage.alt = image['alt'] || productTitle;
              newImage.sizes = sizes;
              newImage.src = previewImage['src'];
              newImage.srcset = generateSrcset(previewImage, [165, 360, 533, 720, 940, 1066]);
              newImage.loading = 'lazy';
              return newImage;
            };

            const checkSwatches = () => {
              document.querySelectorAll('.js-color-swatches-wrapper').forEach((wrapper) => {
                wrapper.querySelectorAll('.js-color-swatches input').forEach((input) => {
                  input.addEventListener('click', (event) => {
                    const primaryImage = wrapper.querySelector('.media--first');
                    const secondaryImage = wrapper.querySelector('.media--second');
                    const handleProduct = wrapper.dataset.product;

                    if (event.currentTarget.checked && primaryImage) {
                      wrapper
                        .querySelector('.js-color-swatches-link')
                        .setAttribute('href', event.currentTarget.dataset.variantLink);
                      if (wrapper.querySelector('.card__add-to-cart button[name="add"]')) {
                        wrapper
                          .querySelector('.card__add-to-cart button[name="add"]')
                          .setAttribute('aria-disabled', false);
                        wrapper
                          .querySelector('.card__add-to-cart button[name="add"] > span')
                          .classList.remove('hidden');
                        wrapper
                          .querySelector('.card__add-to-cart button[name="add"] .sold-out-message')
                          .classList.add('hidden');
                        wrapper.querySelector('.card__add-to-cart input[name="id"]').value =
                          event.currentTarget.dataset.variantId;
                      }

                      const currentColor = event.currentTarget.value;

                      jQuery.getJSON(window.Shopify.routes.root + `products/${handleProduct}.js`, function (product) {
                        const variant = product.variants.filter(
                          (item) => item.featured_media != null && item.options.includes(currentColor)
                        )[0];

                        if (variant) {
                          const newPrimaryImage = createImageElement(
                            variant['featured_media'],
                            primaryImage.className,
                            primaryImage.sizes,
                            product.title
                          );

                          if (newPrimaryImage.src !== primaryImage.src) {
                            let flag = false;
                            if (secondaryImage) {
                              const secondaryImagePathname = new URL(secondaryImage.src).pathname;
                              const newPrimaryImagePathname = new URL(newPrimaryImage.src).pathname;

                              if (secondaryImagePathname == newPrimaryImagePathname) {
                                primaryImage.remove();
                                secondaryImage.classList.remove('media--second');
                                secondaryImage.classList.add('media--first');
                                flag = true;
                              }
                            }
                            if (flag == false) {
                              primaryImage.animate(
                                { opacity: [1, 0] },
                                {
                                  duration: 200,
                                  easing: 'ease-in',
                                  fill: 'forwards',
                                }
                              ).finished;
                              setTimeout(function () {
                                primaryImage.replaceWith(newPrimaryImage);
                                newPrimaryImage.animate({ opacity: [0, 1] }, { duration: 200, easing: 'ease-in' });
                                if (secondaryImage) {
                                  secondaryImage.remove();
                                }
                              }, 200);
                            }
                          }
                        }
                      });
                    }
                  });
                });
              });
            };

            const initProductCarouselSliders = () => {
              const prodCarslideshows = document.querySelectorAll('.product-recommendations-swiper');

              prodCarslideshows.forEach((prodSlideshow) => {
                const productCount = parseInt(
                  prodSlideshow.querySelector('.swiper-wrapper').getAttribute('data-count')
                );

                const productCountMobile = parseInt(
                  prodSlideshow.querySelector('.swiper-wrapper').getAttribute('data-count-mobile')
                );

                const prodCardprodSlideshow = new Swiper(prodSlideshow, {
                  loop: false,
                  autoHeight: true,
                  allowTouchMove: true,
                  slidesPerView: productCount,
                  lazy: true,
                  preloadImages: false,
                  spaceBetween: 24,
                  watchSlidesProgress: true,
                  preventInteractionOnTransition: true,
                  mousewheel: {
                    forceToAxis: true,
                  },
                  navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                  },
                  on: {
                    resize: function () {
                      var windowWidth = window.innerWidth;

                      if (productCount == 6) {
                        if (windowWidth < 576) {
                          this.params.slidesPerView = productCountMobile;
                        } else if (windowWidth < 750) {
                          this.params.slidesPerView = 2;
                        } else if (windowWidth < 1100) {
                          this.params.slidesPerView = 3;
                        } else if (windowWidth < 1360) {
                          this.params.slidesPerView = 4;
                        } else if (windowWidth < 1600) {
                          this.params.slidesPerView = 5;
                        } else {
                          this.params.slidesPerView = 6;
                        }
                      } else if (productCount == 5) {
                        if (windowWidth < 576) {
                          this.params.slidesPerView = productCountMobile;
                        } else if (windowWidth < 750) {
                          this.params.slidesPerView = 2;
                        } else if (windowWidth < 1100) {
                          this.params.slidesPerView = 3;
                        } else if (windowWidth < 1360) {
                          this.params.slidesPerView = 4;
                        } else {
                          this.params.slidesPerView = 5;
                        }
                      } else if (productCount == 4) {
                        if (windowWidth < 576) {
                          this.params.slidesPerView = productCountMobile;
                        } else if (windowWidth < 750) {
                          this.params.slidesPerView = 2;
                        } else if (windowWidth < 1100) {
                          this.params.slidesPerView = 3;
                        } else {
                          this.params.slidesPerView = 4;
                        }
                      } else if (productCount == 3) {
                        if (windowWidth < 576) {
                          this.params.slidesPerView = productCountMobile;
                        } else if (windowWidth < 750) {
                          this.params.slidesPerView = 2;
                        } else {
                          this.params.slidesPerView = 3;
                        }
                      } else if (productCount == 2) {
                        if (windowWidth < 576) {
                          this.params.slidesPerView = productCountMobile;
                        } else {
                          this.params.slidesPerView = 2;
                        }
                      }
                    },
                  },
                });
              });
            };

            checkSwatches();
            initProductCarouselSliders();
          })
          .catch((e) => {
            console.error(e);
          });
      };

      new IntersectionObserver(handleIntersection.bind(this), {
        rootMargin: '0px 0px 200px 0px',
      }).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
